export default "__VITE_ASSET__9a2cb81a__"